import React from 'react';
import { Container, Paper, Toolbar, Tabs, Tab, Box } from '@mui/material';
import { useLocation, Link, Routes, Route, Outlet, useParams } from 'react-router-dom';
import ServiceTypesList from './servicetypes';
import ServiceType, { ServiceTypeCreate } from './servicetype';

export default function ServiceTypesIndex() {
  const location = useLocation();

  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route index element={<ServiceTypesList />} />
              <Route path="_create" element={<ServiceTypeCreate />} />
              <Route path=":id" Component={() => <ServiceType id={parseInt(useParams().id!)} />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
